import styled from "styled-components"

const Container = styled.div`
        display: flex;
        flex-direction: column;
        height: 80vh;
        width: 80vw;
        padding-bottom: ${props => (props.$isMultTurns ? '6vh' : '0')};
        @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
            width: 100%;
        }
        `

const Header = styled.div`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding: 10px;
        gap: 24px;
        margin-bottom: 12px;

        @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
            display: none;
        }
        `


const MobileToggle = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`

const MobileActionsRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-bottom: 20px;
`

const MobileActionButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 8px;
  border: 1px solid ${p => p.theme.colors.greys.border};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${p => p.theme.colors.text.titleText};
  background-color: ${p => p.theme.colors.brand.white};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${p => p.theme.colors.brand.blueOmint};
  }
`

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 75px;
  margin-bottom: 20px;
  padding: 6px 8px;
  border: 1px solid ${p => p.theme.colors.greys.border};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${p => (p.$active ? p.theme.colors.brand.blueOmint : p.theme.colors.brand.white)};
  color: ${p => (p.$active ? p.theme.colors.brand.white : p.theme.colors.text.titleText)};
  border-color: ${p => (p.$active ? p.theme.colors.brand.blueOmint : p.theme.colors.greys.border)};

  &:hover {
    border-color: ${p => p.theme.colors.brand.blueOmint};
  }
`

const SearchSection = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 15px;
        border: 1px solid ${props => props.theme.colors.greys.dividerGray};
        border-radius: 8px;
        margin-bottom: 24px;
        `

const EditSearchSection = styled.div`
        width: 100%;
        `

const FilterGrid = styled.div`
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 15px;
        margin-bottom: 20px;
        `

const FilterGroup = styled.div`
        display: flex;
        flex-direction: column;
        `

const SearchButtonsContainer = styled.div`
        display: flex;
        gap: 10px;
        `

const SearchInfo = styled.div`
        display: flex;
        flex-direction: column;
        gap: 6px;
        `

const ContentWrapper = styled.div`
        display: flex;
        flex: 1;
        overflow: hidden;

        `

const Sidebar = styled.div`
        width: 50%;
        overflow-y: auto;
        margin-right: 10px;
        display: ${p => p.$hidden ? 'none' : 'block'};

        @media (max-width: 768px) {
            width: 100%;
        border-right: none;
        margin-right: 0;
        display: ${p => p.$hidden ? 'none' : 'block'};
    }
        `

const FilterToggle = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: ${props => props.theme.colors.text.titleText};
        margin-bottom: 1rem;
        `

const Toggle = styled.label`
        position: relative;
        display: inline-block;
        width: 50px;
        height: 24px;
        `

const ToggleInput = styled.input`
        opacity: 0;
        width: 0;
        height: 0;

        &:checked + span {
            background-color: ${p => p.theme.colors.brand.blueOmint};
    }

        &:checked + span:before {
            transform: translateX(26px);
    }
        `

const ToggleSlider = styled.span`
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${p => p.theme.colors.greys.sliderOff};
        transition: 0.4s;
        border-radius: 24px;
        box-shadow: inset 0 0 0 1px ${p => p.theme.colors.greys.sliderBorder};

        &:before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 3px;
        bottom: 3px;
        transition: 0.4s;
        border-radius: 50%;
        background-color: ${p => p.theme.colors.brand.white};
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    }
        `

const ResultsList = styled.div`
        padding: 0;
        `


const Card = styled.div`
        border: 1px solid ${props => props.$selected ? props.theme.colors.brand.selectedBorder : props.theme.colors.greys.dividerGray};
        border-width: ${props => props.$selected ? '2px' : '1px'};
        cursor: ${props => props.$selectable ? 'pointer' : 'default'};
        margin-bottom: ${props => props.$compact ? '15px' : '1rem'};
        border-radius: 8px;
        padding: ${props => props.$compact ? '15px' : '16px'};
        background-color: ${props => props.$selected ? props.theme.colors.brand.selectedBg : props.theme.colors.brand.white};
        transition: all 0.2s ease;

        &:hover {
            background-color: ${props => props.$selected ? props.theme.colors.brand.selectedBg : props.theme.colors.greys.cardHoverBg};
            ${props => props.$compact && `border-color: ${props.theme.colors.greys.cardHoverBorder};`}
    }
        `

const LocationInfo = styled.div`
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: ${props => props.$compact ? '10px' : '8px'};
        font-size: ${props => props.$compact ? '13px' : '14px'};
        ${props => props.$compact && `color: ${props.theme.colors.text.mutedText};`}
        `

const AppointmentInfo = styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 10px 0;
        font-size: ${props => props.$compact ? '13px' : '14px'};
        ${props => props.$compact && `color: ${props.theme.colors.text.mutedText};`}
        `

const MapWrapper = styled.div`
        flex: 1;
        position: relative;
        display: ${p => p.$hidden ? 'none' : 'block'};

        @media (max-width: 768px) {
            display: ${p => p.$hidden ? 'none' : 'block'};
    }
        `

/**
 * Contenedor base de los modales bottom-sheet (filtros mobile y clínica).
 * $zIndex y $mobileOnly cubren las diferencias entre ambos usos.
 */
const ModalWrapper = styled.div`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: ${props => props.$zIndex || 1000};
        display: ${props => props.$mobileOnly ? 'none' : 'flex'};
        align-items: flex-end;

        @media (max-width: 768px) {
            display: flex;
    }
        `

const ModalOverlay = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.4);
        `

const ModalContent = styled.div`
        position: relative;
        background-color: ${props => props.theme.colors.brand.white};
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        border-radius: 16px 16px 0 0;
        padding: 20px;
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
        animation: slideUp 0.3s ease-out;

        @keyframes slideUp {
            from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
        `

const ModalHeader = styled.div`
        display: flex;
        align-items: ${props => props.$align || 'center'};
        justify-content: space-between;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid ${props => props.theme.colors.greys.dividerGray};
        `

const ModalTitle = styled.h2`
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 ${props => props.$mb || '0'} 0;
        color: ${props => props.theme.colors.text.titleText};
        `

const CloseButton = styled.button`
        background: none;
        border: none;
        font-size: 28px;
        color: ${props => props.theme.colors.greys.iconGrey};
        cursor: pointer;
        padding: 0;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.2s ease;
        margin-top: ${props => props.$mt || '0'};

        &:hover {
            background-color: ${props => props.theme.colors.greys.hoverBg};
        color: ${props => props.theme.colors.text.titleText};
    }
        `

const ModalFilterGrid = styled.div`
        display: grid;
        grid-template-columns: 1fr;
        gap: 15px;
        margin-bottom: 20px;
        `

const ModalFooter = styled.div`
        display: flex;
        gap: 10px;
        margin-top: 20px;
        padding-top: 15px;
        border-top: 1px solid ${props => props.theme.colors.greys.dividerGray};
        `

const SearchDiv = styled.div`
    display: flex;
    gap: 12px;
`

const SearchHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

export {
        Container,
        Header,
        MobileToggle,
        MobileActionsRow,
        MobileActionButton,
        ToggleButton,
        SearchSection,
        EditSearchSection,
        FilterGrid,
        FilterGroup,
        SearchButtonsContainer,
        SearchInfo,
        ContentWrapper,
        Sidebar,
        FilterToggle,
        Toggle,
        ToggleInput,
        ToggleSlider,
        ResultsList,
        Card,
        LocationInfo,
        AppointmentInfo,
        MapWrapper,
        ModalWrapper,
        ModalOverlay,
        ModalContent,
        ModalHeader,
        ModalTitle,
        CloseButton,
        ModalFilterGrid,
        ModalFooter,
        SearchDiv,
        SearchHeader
}
